<template>
  <div
    class="rt-table-title rttbltit no-scroll-track"
    :class="{ rttbltit_flipped: flipped }"
  >
    <div class="rttbltit_left">
      <slot name="left" />
    </div>
    <div class="rttbltit_right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Studyrange',
  props: {
    flipped: Boolean,
  },
}
</script>
<style lang="scss" scoped>
.rttbltit {
  width: 100%;

  display: flex;
  gap: 0.25rem;

  justify-content: space-between;
  align-items: flex-end;

  --rt-title-padding: 0rem 0.25rem 0.25rem 0.25rem;
  --rt-title-gap: 0.75rem;
  --rt-title-height: 2rem;
  padding: var(--rt-title-padding);
  font-size: 1.125rem;

  &_left,
  &_right {
    display: flex;
    gap: var(--rt-title-gap);
    justify-content: center;
    align-items: center;
    min-width: 0;
    height: 100%;
  }

  &_flipped {
    flex-direction: row-reverse;
    .rttbltit_left {
      flex-direction: row-reverse;
    }
    .rttbltit_right {
      flex-direction: row-reverse;
    }
  }
}

@media (max-width: 380px) {
  .rttbltit {
    --rt-title-gap: 0.25rem;
    &_left,
    &_right {
      flex-direction: column;
      justify-content: flex-end;
    }
    &_flipped {
      .rttbltit_left,
      .rttbltit_right {
        flex-direction: column;
        align-items: flex-end;
      }
    }
  }
}
</style>
